export default import.meta.ROLLDOWN_FILE_URL_3_78jJlEnRzZwIKkZ_ZS6w